import { ClienteCampoPersonalizado } from './cliente-campo-personalizado';
import { ClienteCampoPersonalizadoSelecionado } from './cliente-campo-personalizado-selecionado';
import { KitLayout } from './kit-layout';
import { MicInvComb } from './mic-inv-comb';
import { ParametrosKit } from './parametros-kit';

export class Produto {
  idProduto: number;
  codBarra: string;
  referencia: string;
  descricao: string;
  precoCusto: number;
  precoVenda: number;
  precoFinalSugerido: number;
  qtEstoque: number;
  qtEstoqueMinimo: number;
  estoque: string;
  pesavel: string;
  situacao: string;
  unidade: string;
  maxDe: number;
  cc: number;
  tamanho: number;
  producao: number;
  potencia: number;
  // qt: string;
  marca: number;
  fornecedor: string;
  obs: string;
  margem: number;
  noct: number;
  coefPmax: number;
  tipoUso: string;
  dataPreco: Date;
  horaPreco: string;
  familia: number;
  franquia: number;
  setor: number;
  grupo: number;
  foto: any;
  fotoUrl: string;
  fotoUrlAnterior: string;
  produtoEstrutura: string;
  dataSheet: string;
  qtReserva: number;
  tipoIntegracao: number;

  idProdutoDuplicado: number;
  fornecedores: number[];
  descontos: ProdutoDesconto[];
  largura: number;
  peso?: number;
  altura?: number;
  comprimento?: number;
  eficiencia?: number;
  imp?: number;
  isc?: number;
  tensao?: number;
  tipoLigacaoInv?: number;
  tipoInv?: number;
  potSaidaInv?: number;
  potEntradaInv?: number;
  mpptInv?: number;
  entradasInv?: number;
  entradasSb?: number;
  saidasSb?: number;
  modelo?: string;
  composicao: ProdutoKit[];
  moduloComposicao: ProdutoKit;
  inversorComposicao: ProdutoKit;
  parametrosInversor: ParametrosKit[];
  parametrosConector: ParametrosKit[];
  parametrosStringbox: ParametrosKit[];
  parametrosCabo: ParametrosKit[];
  parametrosCombo: ParametrosKit[];
  qtdParametrosConector: number;
  qtdParametrosStringBox: number;
  codErp: string;
  precoAvulso: number;
  atualizaErp: string;

  idFornecedor: number;
  descricaoFornecedor: string;

  telhado: number;
  telhadoDescricao: string;
  maisVendido: boolean;
  promocional: boolean;
  aparecerAvulso: boolean;
  nacionalidade: number;
  mInvRegra: string;

  descricaoResumida: string;

  combinacoesMicroInversor: MicInvComb[];

  codErpConectorPainel: string;

  marketPlace: boolean;

  descComplementar: string;
  dtDisponibilidade: Date;

  descricaoAtual: string;

  layouts: KitLayout[];
  visibilidade: number;

  qtDeposito: number;
  exibirCalculoPotencia: boolean;

  camposPersonalizados: ClienteCampoPersonalizadoSelecionado[];
  camposPersonalizadosMontar: ClienteCampoPersonalizado[];

  situacaoAtual: string;
  nomeUsuarioSituacao: string;
  nomeFuncionarioSituacao: string;
  dataHoraSituacao: Date;

  obsKit: string;

  semLote: boolean;

  multiplo: boolean;
  valorMultiplo: number;

  menuOrigem: number = 0;

  //Aparecer no Menu Monte Seu Kit
  aparecerMSK: boolean;
  categoria: number;

  ipi: number;
}

export class ProdutoDesconto {
  idDesc: number;
  produto: number;
  qtdIni: number;
  qtdFim: number;
  desco: number;
  descoCusto: number;

  situacao: number;
  emLote: boolean;

  descontoInicial: number;
  descontoFinal: number;
  descontoInicialCusto: number;
  descontoFinalCusto: number;
}

export class Familia {
  idFamilia: number;
  descricao: string;
}

export class ProdutoKit {
  idKit: number;
  proKit: number;
  proMP: number;
  qt: number;
  produtoMP: Produto;
}

export class QtdProduto {
  idProduto: number;
  qtd: number;
}
